import React,{useEffect,useState,useCallback} from 'react';
import {SysPath} from 'SysContext';
import {RAjax} from '@putil-view/request.r-ajax';
import {RSpinner} from '@putil-view/item.r-spinner';
import {QrPrintArea,QrPrintResult,QrNextId, QrCardReader} from './components';
import {useQuery} from '@putil-view/use.use-query';
import Container from 'react-bootstrap/Container';
import 'css/qr-print.css';

const QrPrint = (props) => {
	const query = useQuery();
	const [state, setState] = useState({stage:"REQUEST_SID", id:null, sid:null,uuid:null,printRecord:null,message:""})
	const type = query.get('type');
	const params = query.getParams({
		mode:"url",
		type:type,
		id:'',
		loopTo:'',
		top:type === 'locker' ? '8.8mm' :'5.0mm',
		left:type === 'locker' ? '9mm' :'9mm',
		fontSize:type === 'locker' ? "7mm" :'3.5mm',
		size:type === 'locker' ? 120 : 64.25196850393701,
		rightFontSize:'2.2rem',
		rightFontPaddingLeft:'0.63rem'
	})
	if(params.mode === 'card' && state.id !== null)
		params.id = state.id;
	const handleRequestedUUID = useCallback((data) =>{
		if (params.id && params.type && data && data.uuid){
				setState((prevState)=> {return {
					...prevState,
					stage:'OPEN_PRINT_DIALOG',
					uuid:data.uuid}
				});
		}
		else if(data && (!data.uuid)){
			alert(params.id + ' is not found');
			setState((prevState)=>{return {
				...prevState,
				stage:'ERROR',
				errorMessage:"id + ' is not found'"}}
			);
		}
	},[params.id,params.type])

	const handleAddedPrintRecord = useCallback((data)=>{
		if(data && data.dt){
			setState((prevState)=>{
					return{...prevState,...{
						stage: "RESULT",
						printRecord: data,
					}}
			});
		}
		else{
			setState((prevState)=>{
				return{...prevState,...{
						stage: 'ERROR',
						errorMessage: "Unable to add Print record. Please contact system admin via cshingli@Polyu.edu.hk"
					}
				}
			});
		}
	},[]);

	const handleNextId = useCallback((nextId)=>{
		query.set("id", nextId);
		query.updateBrowserQuery();
		setState((prevState) => {return{...prevState,stage:'REQUEST_UUID'}})
	},[query]);

	const handleChangeID = useCallback((event)=>{
		if(event.error.message.length === 0)
			setState((prevState)=>{return{...prevState,sid:event.target.value,stage: 'REQUEST_LOCKER_NUMBER'}})
	},[])

	const handleRequestedLockerNumber = useCallback((data) =>{
		if(data === undefined || data === null || data.id === undefined || data.id === null || data.id === ""){
			setState((prevState)=>{return{...prevState,
				stage:'REQUEST_SID',
				message:<><b className="text-danger">Locker allocated for student id: {state.sid} is not found. Please contact SAO colleague to confirm your locker allocation status</b></>
			}});
		}
		if (data && data.id){
				setState((prevState)=>{return{...prevState,
					stage:'REQUEST_UUID',
					id:data.id,
					message:""
				}});
		}
	},[state.sid])
	useEffect(()=>{
		if(params.mode === "url"){
			setState((prevState) => {return {...prevState, stage: 'REQUEST_UUID'}});
		}
	},[params.mode])
	useEffect(()=>{
		if(params.mode === "card" && state.stage === "RESULT"){
			setState({
				stage:"REQUEST_SID",
				id:null,
				sid:null,
				uuid:null,
				printRecord:null,
				message:<><b className="text-success">Done. Print record uploaded sucessfully.</b></>
			});
		}
	},[params.mode, state.stage])
	useEffect(()=>{

		if(state.stage === "OPEN_PRINT_DIALOG"){
			window.print();
			setState((prevState) => {return{...prevState,stage:'ADD_PRINT_RECORD'}})
		}
	},[params,query,state.stage])

	return (
		<>
			{state.stage === 'REQUEST_SID' &&
				<>
				<QrCardReader message={state.message} handleChangeID={handleChangeID}/>

				</>
			}
			{state.stage === 'REQUEST_LOCKER_NUMBER' &&
				(()=>{
					const getLockerNumberUrl = SysPath.getLockerNumberUrl + "?sid="+state.sid;
					return(
						<Container className="justify-content-center">
							{(params.id || state.sid) && params.type  &&
								<Container>
									<span className="text-center"> <RSpinner/></span>
									<h5 className="text-center">Finding Locker Number for {state.sid}</h5>

								</Container>
							}
							<RAjax requestOptions={{
										method: 'get',
										withCredentials: true,
										url: getLockerNumberUrl
									}}
								handleResponse={handleRequestedLockerNumber}
							/>
						</Container>
					)
				})()
			}
			{state.stage === 'REQUEST_UUID' &&
				(()=>{
					const getUuidUrl = SysPath.getUuidUrl + "?id="+params.id+"&type="+params.type;
					return(
						<Container className="justify-content-center">
							{params.id && params.type &&
								<Container>
									<span className="text-center"> <RSpinner/></span>
									<h5 className="text-center">Finding QR code for {params.id}{'\'s'} {params.type}</h5>

								</Container>
							}
							<RAjax requestOptions={{
										method: 'get',
										withCredentials: true,
										url: getUuidUrl
									}}
								handleResponse={handleRequestedUUID}
							/>
						</Container>
					)
				})()
			}
			{state.stage === 'ADD_PRINT_RECORD' &&
				(()=>{
					const addPrintRecordUrl = SysPath.addPrintRecordUrl;
					return(
						<>
							<Container>
								<span className="text-center"> <RSpinner/></span>
								<h5 className="text-center">Adding Print Record for {params.id}{'\'s'} {params.type}</h5>
							</Container>

							<RAjax requestOptions={{
										method: 'post',
										withCredentials: true,
										headers: {
											"Content-Type": "application/json"
										},
										data: {text:params.id, type:params.type},
										url: addPrintRecordUrl
									}}
									handleResponse={handleAddedPrintRecord}
							/>
						</>
					)
				})()
			}
			{(state.stage === "OPEN_PRINT_DIALOG") &&
				<QrPrintArea
					params={params}
					uuid={state.uuid}
				/>
			}
			{state.stage === "ERROR" &&
				<b className="text-danger">{state.errorMessage}</b>
			}
			{state.stage === "RESULT" &&
				<>
					<QrPrintResult
						type={params.type}
						lockerId={params.id}
						printArea={
							<QrPrintArea
								params={params}
								uuid={state.uuid}
							/>
						}
						dt={state.printRecord['dt']}
					/>
					<QrNextId id={params.id} loopTo={params.loopTo} handleNextId={handleNextId}/>
				</>
			}
		</>
	)
}
export default QrPrint;
